module.exports = __webpack_public_path__ + "img/T935.36aa2af5.jpg";